import React from 'react';
import Slider from 'material-ui/Slider';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import './RateSlider.css';

const muiTheme = getMuiTheme({
  slider: {
    selectionColor: '#d52b1e',
    handleFillColor: '#d52b1e',
  },
});

const RateSlider = props => (
  <MuiThemeProvider muiTheme={muiTheme}>
    <div>
      <div style={{ marginLeft: 100 - ((1 - props.rate) * 150), marginBottom: -20, marginTop: 10, width: 30, height: 30, display: 'flex', justifyContent: 'center', zIndex: 100, alignItems: 'center', borderRadius: 10, backgroundColor: '#d52b1e' }} className="slider-current">{`x${props.rate}`}</div>
      <div className="sliderBox">
        <div className="slider-range">0.5</div>
        <Slider
          className="slider"
          disabled={!props.isStopped()}
          min={0.5}
          max={1.5}
          axis="x"
          value={props.rate}
          disableFocusRipple
          onChange={(e, value) => props.setRate(value)}
          step={0.1}
        />
        <div className="slider-range">1.5</div>
      </div>
      <div className="slider-header">Playback rate</div>
    </div>
  </MuiThemeProvider>
    );

export default RateSlider;



// WEBPACK FOOTER //
// ./src/components/RateSlider.js